/*
 * tp-gen-compare — Smartphone-Generationsvergleich (Custom Element)
 * Portiert aus talk-point-de-v1 (sections/tp-gen-vergleich.liquid +
 * snippets/tp-gen-vergleich-set.liquid), Wertungs-Logik unverändert, konsolidiert.
 *
 * Liest das eingebettete <script type="application/json" class="tpgc-data">.
 *   mode 'pdp-auto' : Zeitachse (Vorgänger/Nachfolger) + Klassen-Aufstiegspfad
 *   mode 'set'      : eine mehrspaltige Tabelle mit „Nur Unterschiede"-Toggle
 * Gewinner-/Cross-Brand-/Kohorten-Wertung aus dem eingebetteten Wörterbuch.
 */
(function () {
  if (customElements.get('tp-gen-compare')) return;

  var PDP_ROWS = ['besonderheit', 'chip', 'display_zoll', 'display_hz', 'kamera_mp', 'kamera_tele', 'akku_mah', 'anschluss', 'updates_bis'];

  function esc(s) {
    return ('' + s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }
  function disp(m) {
    return (m.n || '')
      .replace(/^Apple iPhone /, '').replace(/^Google Pixel /, '').replace(/^Samsung Galaxy /, '')
      .replace(/^Xiaomi /, '').replace(/^OPPO /, '').replace(/^OnePlus /, '')
      .replace(/^HONOR /, '').replace(/^Motorola /, '');
  }

  class TPGenCompare extends HTMLElement {
    connectedCallback() {
      if (this.__tpgcInit) return;
      this.__tpgcInit = true;

      const dataEl = this.querySelector('.tpgc-data');
      if (!dataEl) return;
      let data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      this.ATTR = data.dict.attrs;
      this.CONFIG = data.dict.config || {};
      this.SC = this.CONFIG.serie_config || {};
      this.MODELS = data.models || [];
      this.MODE = data.mode;
      this.CENTER = data.center;
      this.mount = this.querySelector('.tpgc-mount');

      if (!this.mount || !this.MODELS.length) { this.style.display = 'none'; return; }

      if (this.MODE === 'pdp-auto') {
        this.renderPdp();
      } else {
        const box = this.querySelector('.tpgc-diff');
        const paint = () => { this.mount.innerHTML = this.renderSet(box ? box.checked : false); };
        if (box) box.addEventListener('change', paint);
        paint();
      }
    }

    /* ── Wertungs-Helfer (v1 verbatim) ───────────────────────────── */
    cmpval(m, key) {
      const a = this.ATTR[key]; if (!a) return null;
      if (a._ref) return (m.a[a._ref] != null) ? m.a[a._ref] : null;
      const v = m.a[key]; if (v == null) return null;
      if (a.typ === 'bool') return v ? 1 : 0;
      if (a.typ === 'zahl') return +v;
      if (a.typ === 'enum') { const r = a.rang; return (r && r.indexOf(v) >= 0) ? -(r.indexOf(v)) : null; }
      return null;
    }
    crossOk(x, y, key) {
      if (x.b === y.b) return true;
      const mode = this.ATTR[key].cross_brand; if (mode === 'nein') return false;
      if (mode === 'referenz') return !!this.ATTR[key]._ref;
      return true;
    }
    winner(ms, key) {
      const a = this.ATTR[key];
      if (!a || (a.besser !== 'hoch' && a.besser !== 'niedrig')) return -1;
      for (let i = 0; i < ms.length; i++) for (let j = 0; j < ms.length; j++) if (i !== j && !this.crossOk(ms[i], ms[j], key)) return -1;
      const vals = ms.map((m) => this.cmpval(m, key));
      if (vals.some((v) => v == null)) return -1;
      const delta = a.rausch_delta || 0, best = (a.besser === 'hoch') ? Math.max.apply(null, vals) : Math.min.apply(null, vals);
      const wins = []; vals.forEach((v, i) => { if (v === best) wins.push(i); }); if (wins.length !== 1) return -1;
      const wi = wins[0]; for (let k = 0; k < vals.length; k++) if (k !== wi && delta && Math.abs(vals[wi] - vals[k]) <= delta) return -1;
      return wi;
    }
    // Zeile ist ein echter Unterschied, wenn sich mind. zwei Werte real unterscheiden.
    // Zahl: erst ab > rausch_delta. So gelten 3240 vs 3279 mAh als „gleich".
    isDiff(ms, key) {
      const a = this.ATTR[key] || {}, delta = a.rausch_delta || 0;
      const vals = ms.map((m) => { const v = m.a[key]; return v == null ? null : v; });
      const seen = vals.filter((v) => v != null);
      if (seen.length < 2) return seen.length === 1 && vals.some((v) => v == null);
      for (let i = 0; i < vals.length; i++) for (let j = i + 1; j < vals.length; j++) {
        const x = vals[i], y = vals[j]; if (x == null || y == null) { if (x !== y) return true; continue; }
        if (a.typ === 'zahl') { if (Math.abs((+x) - (+y)) > delta) return true; }
        else if (x !== y) return true;
      }
      return false;
    }
    fmt(key, v) {
      const a = this.ATTR[key]; if (v == null) return '—';
      if (a.typ === 'bool') return v ? 'Ja' : '—';
      if (a.typ === 'zahl') {
        if (key === 'display_zoll') return ('' + v).replace('.', ',') + '”';
        if (a.einheit === 'Jahr') return 'bis ' + Math.round(v);
        if (a.einheit === 'mAh') return Math.round(v).toLocaleString('de-DE') + ' mAh';
        if (a.einheit) return (Number.isInteger(v) ? v : ('' + v).replace('.', ',')) + ' ' + a.einheit;
        return '' + v;
      }
      return '' + v;
    }

    /* ── PDP-Auswahl (Zeitachse + Aufstiegspfad) ─────────────────── */
    cohort(m) { const c = this.SC[m.s] || {}; return (c.rowkey === 'digit') ? (m.g % 10) : m.g; }
    lineOrder(s) { return (this.SC[s] && this.SC[s].lines) || []; }
    timeAxis(center) {
      const sib = this.MODELS.filter((x) => x.s === center.s && x.l === center.l)
        .sort((a, b) => (a.g || 0) - (b.g || 0));
      const i = sib.findIndex((x) => x.h === center.h); if (i < 0) return [center];
      return sib.slice(Math.max(0, i - 1), i + 2);
    }
    upgradePath(center) {
      const ord = this.lineOrder(center.s), ch = this.cohort(center);
      return this.MODELS.filter((x) => x.s === center.s && this.cohort(x) === ch)
        .sort((a, b) => { const ia = ord.indexOf(a.l), ib = ord.indexOf(b.l); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
    }

    /* ── Rendering ───────────────────────────────────────────────── */
    pic(m) {
      if (m.img) return "<div class='pic'><img src='" + esc(m.img) + "' alt='' loading='lazy'></div>";
      return "<div class='pic pic--empty'><svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' aria-hidden='true'><rect x='6.5' y='2' width='11' height='20' rx='2.4'/><path d='M10.5 18.6h3'/></svg></div>";
    }
    renderCmp(ms, cur, rows, onlyDiff) {
      if (!ms.length) return '';
      const head = "<th class='rowhead corner'></th>" + ms.map((m) => {
        const c = cur && m.h === cur;
        const inner = this.pic(m) + "<div class='mname'>" + esc(disp(m)) + " <span class='go'>›</span></div><div class='tier'>" + (m.r || '') + "</div>";
        return "<th scope='col' class='chead" + (c ? " cur" : "") + "'><a class='clink' href='/collections/" + encodeURIComponent(m.h) + "'>" + inner + "</a></th>";
      }).join("");
      let shown = 0;
      const body = rows.map((key) => {
        const ad = this.ATTR[key]; if (!ad) return "";
        if (ms.every((m) => m.a[key] == null)) return "";
        if (onlyDiff && key !== 'besonderheit' && !this.isDiff(ms, key)) return "";
        shown++;
        const wi = this.winner(ms, key), sig = key === 'besonderheit';
        const tds = ms.map((m, i) => {
          const win = i === wi, c = cur && m.h === cur, cls = "cell" + (win ? " win" : "") + ((c && !win) ? " curcol" : "");
          return "<td class='" + cls + "'>" + (win ? "<span class='wtag'>besser</span>" : "") + "<div class='val'>" + esc(this.fmt(key, m.a[key])) + "</div></td>";
        }).join("");
        return "<tr" + (sig ? " class='sigrow'" : "") + "><th scope='row' class='rowhead'><div class='rl'>" + esc(ad.label) + "</div></th>" + tds + "</tr>";
      }).join("");
      if (!shown) return "<div class='tpgc-empty'>Diese Modelle unterscheiden sich in den verglichenen Merkmalen praktisch nicht.</div>";
      // Content-basierte Breite: Label-Spalte 172 + je Modell max. 320px → Spalten
      // strecken sich nicht. max-width:100% (CSS) klemmt auf schmalen Karten,
      // min-width ist der mobile Untergrund fürs horizontale Scrollen.
      const w = 172 + ms.length * 320;
      const minw = 172 + ms.length * 150;
      return "<div class='tablewrap'><table class='cmp' style='width:" + w + "px;min-width:" + minw + "px;max-width:100%'><thead><tr>" + head + "</tr></thead><tbody>" + body + "</tbody></table></div>";
    }
    blockHtml(title, sub, ms, cur, rows, onlyDiff) {
      const inner = this.renderCmp(ms, cur, rows, onlyDiff);
      if (!inner) return '';
      return "<div class='tpgc-block'>" + (title ? "<h3>" + esc(title) + "</h3>" : "") + (sub ? "<div class='sub'>" + esc(sub) + "</div>" : "") + inner + "</div>";
    }

    renderPdp() {
      const center = this.MODELS.find((m) => m.h === this.CENTER);
      if (!center) { this.style.display = 'none'; return; }
      const t = this.timeAxis(center), u = this.upgradePath(center);
      let html = '';
      if (t.length > 1) html += this.blockHtml("Vorgänger und Nachfolger", "Was sich von Generation zu Generation geändert hat.", t, center.h, PDP_ROWS, false);
      if (u.length > 1) html += this.blockHtml("Die Klassen im Vergleich", "Dieselbe Generation, verschiedene Ausstattungen.", u, center.h, PDP_ROWS, false);
      if (!html) { this.style.display = 'none'; return; }
      this.mount.innerHTML = html;
    }
    renderSet(onlyDiff) {
      const rows = this.CONFIG.rows || PDP_ROWS;
      return this.renderCmp(this.MODELS, null, rows, onlyDiff);
    }
  }

  customElements.define('tp-gen-compare', TPGenCompare);
})();
